import React, { FunctionComponent } from 'react';
import { components } from 'react-select';

const Menu: FunctionComponent<React.PropsWithChildren<any>> = (props) => {
  return <components.Menu {...props} className="autocomplete-menu" />;
};

Menu.displayName = 'Menu';

export default Menu;
